
/**
 * Build a thin box geometry whose face brightness is baked into vertex colours.
 * When MeshBasicMaterial.vertexColors is true, the GPU multiplies instanceColor
 * by the vertex colour, so the top face shows the full tile colour while the
 * side faces appear slightly darker — creating a soft bevel without lighting.
 * Generated by Claude Sonnet 4.6 - 2026-04-09
 *
 * BoxGeometry vertex layout (4 verts per face, never shared):
 *   face 0 = +x   face 1 = -x   face 2 = +y (top)
 *   face 3 = -y   face 4 = +z   face 5 = -z
 */
const face_brightness = [0.62, 0.62, 1.00, 0.20, 0.72, 0.55]
const count = 24 // BoxGeometry always has exactly 24 verts (4 per face × 6 faces)
export const bevel_colours = new Float32Array(count * 3)
for (let i = 0; i < count; ++i)
{
    const b = face_brightness[Math.floor(i / 4)] ?? 0.65
    bevel_colours[i * 3    ] = b
    bevel_colours[i * 3 + 1] = b
    bevel_colours[i * 3 + 2] = b
}


export function box_geometry_for_cell_size(cell_size: number)
{
    // const s = cell_size * 0.95    // slight gap visually separates tiles
    const box_geo_s = cell_size * 0.95
    // const h = cell_size * 0.06    // height exposes side faces for the bevel shading
    const box_geo_h = cell_size * 0.1

    return { box_geo_s, box_geo_h }
}
